module.exports = __webpack_public_path__ + "static/media/DSEG7ModernMini-Regular.aaf861a7.woff2";